<template>
  <v-container>
    <div
      class="mt-5"
      :class="{'mx-10': $vuetify.breakpoint.lgAndUp}"
      style="border:1px solid black"
    >
      <v-tabs
        ref="tabs"
        v-model="active"
        align-with-title
        slider-color="white"
        show-arrows
      >
        <v-tab
          v-for="item in filteredTabItems"
          :key="item.name"
          class="divider font-black"
        >
          {{ item.name }}
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="active">
        <v-tab-item
          v-if="$hasPermissionTo(['view job bands'])"
          class="pb-12"
        >
          <setup-job-position-job-band-container-view />
        </v-tab-item>

        <v-tab-item
          v-if="$hasPermissionTo(['view job categories'])"
          class="pb-12"
        >
          <setup-job-position-job-category-container-view />
        </v-tab-item>

        <v-tab-item
          v-if="$hasPermissionTo(['view job groups'])"
          class="pb-12"
        >
          <setup-job-position-job-group-container-view />
        </v-tab-item>

        <v-tab-item
          v-if="$hasPermissionTo(['view job grades'])"
          class="pb-12"
        >
          <setup-job-position-job-grade-container-view />
        </v-tab-item>

        <v-tab-item
          v-if="$hasPermissionTo(['view job titles'])"
          class="pb-12"
        >
          <setup-job-position-job-title-container-view />
        </v-tab-item>
      </v-tabs-items>
    </div>
  </v-container>
</template>

<script>
  export default {
    components: {
      SetupJobPositionJobBandContainerView: () => import('@/components/hris/setup/job-position/job-band/ContainerView'),
      SetupJobPositionJobCategoryContainerView: () => import('@/components/hris/setup/job-position/job-category/ContainerView'),
      SetupJobPositionJobGroupContainerView: () => import('@/components/hris/setup/job-position/job-group/ContainerView'),
      SetupJobPositionJobGradeContainerView: () => import('@/components/hris/setup/job-position/job-grade/ContainerView'),
      SetupJobPositionJobTitleContainerView: () => import('@/components/hris/setup/job-position/job-title/ContainerView'),
    },
    metaInfo () {
      return {
        title: 'Job Position Setups',
      }
    },
    data () {
      return {
        tabItems: [ ],
        active: null,
      }
    },

    computed: {   
      filteredTabItems () {
        let modifiedTab = [...this.tabItems]
 
        if (this.$hasPermissionTo(['view job bands'])) {
          modifiedTab.push({ name: 'Job Band' })
        }

        if (this.$hasPermissionTo(['view job categories'])) {
          modifiedTab.push({ name: 'Job Categories' })
        }

        if (this.$hasPermissionTo(['view job groups'])) {
          modifiedTab.push({ name: 'Job Group' })
        }

        if (this.$hasPermissionTo(['view job grades'])) {
          modifiedTab.push({ name: 'Job Grade' })
        }

        if (this.$hasPermissionTo(['view job titles'])) {
          modifiedTab.push({ name: 'Job Title' })
        }

        return modifiedTab
      },
    },
  }
</script>

<style scoped>
.divider { 
  border-right: 1px solid #707070;
  border-bottom: 1px solid #707070;
} 

.font-black{
  color:black !important;
}

.divider.font-black.v-tab.v-tab--active{
  border-bottom:0px;
}

.v-tab {
  text-transform: none !important;
  max-height: 33px;
}
</style>
